import React, { Fragment } from 'react';
import { useMemo, useState } from 'react';
import { TbChevronDown, TbSearch } from 'react-icons/tb';
import { Flex, Input, Menu, Text, ScrollArea, Tooltip, Checkbox } from '@mantine/core';
import { createStyles } from '@mantine/emotion';
import { TbListDetails } from 'react-icons/tb';
import { idCreator } from '../../../../Project/utils/idCreator';

const useStyles = createStyles(theme => ({
  select: {
    border: `1px solid ${theme.colors.gray[1]}`,
    borderRadius: '4px',
    cursor: 'pointer'
  }
}));

export function FilterSelect({ options = [], title, selectedTitle, onChange }) {
  const { classes } = useStyles();
  const [term, setTerm] = useState();

  const filteredOptions = useMemo(() => {
    if (!options || options.length === 0) return [];

    if (!term) return options;

    return options.filter(item => item.label.toLowerCase().includes(term.toLowerCase()));
  }, [options, term]);

  const onChangeTerm = e => {
    setTerm(e.target.value);
  };

  const defaultRenderOptions = item => (
    <Menu.Item
      id={`formpf-filter-select-option-${idCreator(item.value)}`}
      p={8}
      key={item.value}
      w="100%"
    >
      <Flex align="center" gap="8px">
        <Checkbox
          id={`formpf-filter-select-option-checkbox-${idCreator(item.value)}`}
          size="xs"
          onChange={() => onChange(item.value)}
          checked={item.isSelected}
        />
        <Tooltip
          id={`formpf-filter-select-tooltip-${idCreator(item.value)}`}
          label={item.label}
          disabled={!item.label}
        >
          <Text
            id={`formpf-filter-select-option-label-${idCreator(item.value)}`}
            fz="14px"
            lh="20px"
            lineClamp={2}
          >
            {item.label}
          </Text>
        </Tooltip>
      </Flex>
    </Menu.Item>
  );

  const selectedOptionsSize = useMemo(() => {
    return options?.filter(item => item.isSelected)?.length || 0;
  }, [options]);

  return (
    <Menu id="formpf-filter-select-menu" shadow="md" width={180} closeOnItemClick={false}>
      <Menu.Target>
        <Flex
          id="formpf-filter-select-trigger"
          align="center"
          justify="space-between"
          className={classes.select}
          p="2.5px 12px"
          sx={{
            gap: '8px',
            border: '1px solid #CED4DA'
          }}
          maw={180}
          w={180}
          gap="8px"
        >
          <Flex align="center" gap="8px">
            <TbListDetails size={12} color="#228BE6" />
            <Text
              id="formpf-filter-select-trigger-label"
              fz="12px"
              lh="17px"
              style={{
                color: '#000'
              }}
              truncate="end"
            >
              {selectedOptionsSize === (options?.length || 0)
                ? title
                : `${selectedOptionsSize} ${selectedTitle}(s) selected`}
            </Text>
          </Flex>
          <TbChevronDown size={14} color="#909296" />
        </Flex>
      </Menu.Target>

      <Menu.Dropdown id="formpf-filter-select-dropdown" p="8px" w={180}>
        <Input
          id="formpf-filter-select-search-input"
          placeholder="Search"
          leftSection={<TbSearch size={16} />}
          size="xs"
          mb="8px"
          onChange={onChangeTerm}
          value={term}
        />

        <ScrollArea.Autosize scrollbarSize={14} scrollHideDelay={500} mah="50vh">
          <Menu.Item id="formpf-filter-select-all-option" p={8} key="all" w="100%" mb="8px">
            <Flex align="center" gap="8px">
              <Checkbox
                id="formpf-filter-select-all-checkbox"
                size="xs"
                onChange={() => onChange('all')}
                checked={selectedOptionsSize === (options?.length || 0) && options?.length > 0}
              />

              <Text id="formpf-filter-select-all-label" fz="14px" lh="20px" lineClamp={2}>
                Select All
              </Text>
            </Flex>
          </Menu.Item>
          {filteredOptions.map(item => (
            <Fragment key={item.value}>{defaultRenderOptions(item)}</Fragment>
          ))}
        </ScrollArea.Autosize>
      </Menu.Dropdown>
    </Menu>
  );
}
